<template>
  <div class="evento-codigos-promocion">
    <b-row>
      <b-col cols="12" xl="12">
        <b-card header="Opciones de Filtro">
          <b-form>
            <b-form-group
              label="Buscar"
              label-for="codigoBusqueda"
              :label-cols="1"
              horizontal>
              <b-form-input 
                id="codigoBusqueda" 
                v-model="codigoBusqueda" 
                type="text">
              </b-form-input>
            </b-form-group>
          </b-form>
        </b-card>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <transition name="slide">
        <b-card header="Listado de Códigos">
          <b-table hover
              responsive="sm" 
              class="registro"
              :busy="tableBusy"
              :items="codigosPromocion" 
              :fields="fields"
              :filter="codigoBusqueda"
              :current-page="paginaActual"
              :per-page="registrosPorPagina"
              @filtered="onFiltered">
            <div slot="table-busy" class="text-center">
              <b-spinner class="table-spinner" label="Spinning" />
            </div>
          </b-table>
          <nav>
            <b-pagination size="sm" 
              :total-rows="totalRegistros" 
              :per-page="registrosPorPagina" 
              v-model="paginaActual" prev-text="Prev." next-text="Prox."/>
          </nav>
        </b-card>
        </transition>
      </b-col>
    </b-row>

    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>

          <b-dropdown-item @click.stop="importarCodigos">
            <i class="fa fa-upload"></i>Importar Códigos</b-dropdown-item>

          <b-dropdown-item @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <b-modal ref="importacionModal" 
        title="Importar Códigos de Promoción"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="modalABM">
      <app-importacion-codigos
        :eventoId="parseInt(eventoId)"
        @close="closeImportacion">
      </app-importacion-codigos>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>

    <app-confirm
      :confirmModalVisible="confirmModalVisible"
      :confirmMsj="confirmMsj"
      :confirmOkTitle="confirmOkTitle"
      :confirmCancelTitle="confirmCancelTitle"
      @confirmOk="confirmOk"
      @confirmCancel="confirmCancel">
    </app-confirm>
  </div>
</template>

<script>
import ImportacionCodigos from './ImportacionCodigos.vue'
import Mensaje from  '../shared/msjModal.vue';
import Confirm from  '../shared/confirmModal.vue';
import { msjModal, confirmModal } from '../../mixins/modalDialogs'
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'eventoCodigosPromocion/getField',
  mutationType: 'eventoCodigosPromocion/updateField',
});

export default {
  name: 'Eventos',
  components: {
    appImportacionCodigos: ImportacionCodigos,
    appMensaje: Mensaje,
    appConfirm: Confirm,
  },
  mixins: [ 
    msjModal, 
    confirmModal 
  ],
  data: () => {
    return {
      fields: [
        { 
          key: 'codigoPromocion',
          label: 'Cód. Promoción'
        },
      ],

      tableBusy: false,
      eventoId: 0,
      codigoBusqueda: ''
    }
  },
  computed: {
    ...mapFields([
      'evento',
      'codigosPromocion',
      'paginaActual',
      'registrosPorPagina',
      'totalRegistros',
      'totalPaginas',
    ]),
  },
  created() {
    this.eventoId = 0;
    if (this.$route.params){
      if (this.$route.params.id){
        this.eventoId = this.$route.params.id;
      }
    }

    this.getItems();
  },  
  methods: {
    getItems() {
      this.tableBusy = true;
      this.$store.dispatch('eventoCodigosPromocion/getCodigosPromocion', this.eventoId)
        .then(() => this.tableBusy = false)
        .catch(error => this.showErrorMsj(error));
    },
    goBack () {
      this.$router.push({ name: 'Eventos' });
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    },
    importarCodigos() {
      this.$refs.importacionModal.show();
    },
    closeImportacion(actualizado) {
      this.$refs.importacionModal.hide();
      if (actualizado) {
        this.getItems();
      }
    }
  },
  watch: {
    // 'paginaActual' : function(newVal, oldVal) {
    //   if ( newVal != 0 && oldVal != 0) {
    //     this.getItems();
    //   }
    // },    
  }    
}
</script>

<style>
  /* .eventos .registro table td[aria-colindex="1"] {
    width: 10%;
  }
  .eventos .registro table td[aria-colindex="2"] {
    width: Calc(40% - 30px);
  }
  .eventos .registro table td[aria-colindex="3"] {
    width: 20%;
  }
  .eventos .registro table td[aria-colindex="4"] {
    width: 10%;
  }
  .eventos .registro table td[aria-colindex="5"],
  .eventos .registro table td[aria-colindex="6"] {
    width: 10%;
  }
  .eventos .registro table td[aria-colindex="7"] {
    width: 30px;
  } */
</style>
